export default [
  "Starter",
  "Route 201 (Gras)",
  "See der Wahrheit (Gras)",
  "Route 202 (Gras)",
  "Sandgemme (Geschenk: Pokétch Bonus oder Ei später)",
  "Route 203 (Gras)",
  "Erzelingen (Geschenk: Fossil später)",
  "Erzelingen-Kohlebergwerk (Höhle)",
  "Route 204 (Gras)",
  "Erhebung (Höhle)",
  "Route 205 (Gras)",
  "Windkraftwerk (Gras)",
  "Ewigenau (Evoli-Geschenk in Platin)",
  "Ewigenwald (Gras, mit Partner)",
  "Route 206",
  "Route 207 (Gras)",
  "Schleiede (Ei-Tausch möglich)",
  "Route 208 (Gras)",
  "Herzhofen (Ei von einem NPC)",
  "Turm der Ruhenden (Geisterevent)",
  "Route 209 (Gras)",
  "Trostu (NPC-Tausch, Geschenk)",
  "Geisterturm",
  "Route 210 (Gras)",
  "Route 215 (Gras)",
  "Schleiede (Galaktik-Gebäude)",
  "Route 216 (Gras + Schneefall)",
  "Route 217 (Gras)",
  "Blizzach (Geschenk: Kinoso)",
  "See der Stärke (Gras)",
  "Route 218 (Gras)",
  "Fleetburg (Giftmoor: Gras)",
  "Route 219 (Surfen/Angeln)",
  "Route 220 (Surfen)",
  "Route 221 (Gras)",
  "Sonnewik (NPC-Pokémon-Tausch)",
  "Route 222 (Gras)",
  "Route 223 (Surfen)",
  "Route 224 (Nach Liga, optional)",
  "Siegesstraße (Höhle)",
  "Pokémon Liga",
  // Platin-Exklusiv oder optional:
  "Ruinental (Gras)",
  "Kahlberg (Höhle + Außengelände)",
  "Frühlingspfad (Geisterevent)",
  "Neumond-Insel (Darkrai-Event)",
  "Trommelpfad (Shaymin-Event)",
  "Pokémon-Villa (Eingangsgeschenk)",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];